import {
  FormControl,
  FormLabel,
  Textarea,
  FormErrorMessage,
  FormErrorIcon,
} from '@chakra-ui/react';
import { TeamDescriptionFieldProps } from '../types';

export const TeamDescriptionField = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
}: TeamDescriptionFieldProps) => (
  <FormControl
    isInvalid={!!(errors.description && touched.description)}
    data-testid='create-team-description-field'
  >
    <FormLabel htmlFor='team-description'>Description</FormLabel>
    <Textarea
      id='team-description'
      name='description'
      value={values.description}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder='Enter group description (optional)'
      rows={4}
      data-testid='create-team-description-input'
    />
    {errors.description && touched.description && (
      <FormErrorMessage data-testid='create-team-description-error'>
        <FormErrorIcon />
        {errors.description}
      </FormErrorMessage>
    )}
  </FormControl>
);
